module.exports = __webpack_public_path__ + "static/media/blog-page-2.5fa2b962.jpg";